
export const isGreeting = (text = "") => {
  return /^(hi|hii+|hello|hey|welcome)(\b|$)/i.test(text.trim());
};

export const isConfusedReply = (text = "") => {
  return /(dont know|no idea|anything|whatever)/i.test(text);
};

export const isInterrupt = (text = "") => {
  return /(policy|leave policy|help|cancel|stop|start over)/i.test(text);
};

export const isExplicitApplyLeave = (text = "") => {
  // Match leave-apply phrases but NOT when the user says "wfh" / "work from home"
  return (
    /(apply leave|apply for leave|take leave|leave apply)/i.test(text) &&
    !/(wfh|work from home)/i.test(text)
  );
};

export const isExplicitApplyWFH = (text = "") => {
  return /(apply wfh|wfh apply|apply for wfh|work from home apply|request wfh|wfh request|apply work from home)/i.test(text);
};

export const isCancel = (text = "") => {
  return /^(cancel|stop|exit|dont want to apply|no need leave|no need wfh)$/i.test(text.trim());
};
